import { render, staticRenderFns } from "./base-page.vue?vue&type=template&id=5ec86fd7&scoped=true&"
import script from "./base-page.vue?vue&type=script&lang=js&"
export * from "./base-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec86fd7",
  null
  
)

export default component.exports